class AIDesignParams {
  static updateParams(state, params) {
    state = state.mergeIn(['aiDesignParams'], params);
    return { updatedState: state };
  }
}

export { AIDesignParams as default };